import { Component } from '@angular/core';
import { PagetoolbarComponent } from '../pagetoolbar/pagetoolbar.component';
import { MatchStartComponent } from './match-start/match-start.component';
import { MatchProgressComponent } from './match-progress/match-progress.component';
import { MatchErrorComponent } from './match-error/match-error.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-match-run',
  imports: [PagetoolbarComponent, MatchStartComponent, MatchProgressComponent, MatchErrorComponent, CommonModule],
  templateUrl: './match-run.component.html',
  styleUrl: './match-run.component.scss'
})
export class MatchRunComponent {}
